import GetStartedNow from "./GetStartedNow";

export default GetStartedNow;
